import dayjs from 'dayjs';
import { useState } from 'react';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import { NotesRow } from '../index';
import { DaysRow } from '../index';
import { StyledTableHead } from './TableHeader.styles';
import { cloneSchedule } from '../../../../redux/shifts/shiftsService';
import { showSuccessToast } from '../../../../utils/toastUtils';

const TableHeader = ({ daysOfWeek, unassignedShiftsCount }) => {
  const [days, setDays] = useState([]);
  const [notes, setNotes] = useState({});
  const [target, setTarget] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleNoteChange = (date, newNote) => {
    setNotes((prevNotes) => ({
      ...prevNotes,
      [date]: newNote,
    }));
  };

  const toggleDayActions = (e, day) => {
    setDays(daysOfWeek.filter(_ => _.count > 0));
    setAnchorEl(e.currentTarget);
    setTarget(day.date);
  };

  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCopy = async (day) => {
    setIsLoading(true);
    const result = await cloneSchedule(day, target);
    const { valid, invalid } = result.data;

    showSuccessToast(`${valid + invalid} shift${valid + invalid === 1 ? '' : 's'} copied successfully`);
    setIsLoading(false);
    handleClose();
  };

  return (
    <StyledTableHead>
      <DaysRow
        daysOfWeek={daysOfWeek}
        onClick={toggleDayActions}
        unassignedShiftsCount={unassignedShiftsCount}
      />
      <NotesRow
        daysOfWeek={daysOfWeek}
        notes={notes}
        onNoteClick={handleNoteChange}
      />
      <Menu
        id="basic-menu"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'basic-button',
          },
        }}
      >
        {!days.length && (
          <MenuItem onClick={handleClose}>No schedule available</MenuItem>
        )}
        {isLoading
          ? (
            <MenuItem disabled>Cloning schedule...</MenuItem>
          )
          : days.map(({ day, date }) => (
          <MenuItem key={day} onClick={() => handleCopy(date)}>
            Copy schedule from {dayjs(date).format('dddd')} to {dayjs(target).format('dddd')}
          </MenuItem>
        ))}
      </Menu>
    </StyledTableHead>
  );
};

export default TableHeader;
